// extracted by mini-css-extract-plugin
export default {"card":"LatestCard_card__x352Y"};